export const init = () => {

  // TRACKER 'HOMEPAGE - SPORTS ADVICE'
  const sep = AnalyticsConstants.concatenator;
  const fwk = CUBE.Analytics;
  const utils = fwk.utils;

  const defaultContainer = '#sports-advice';
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.homepage.sportsadvice);

  if (tc_vars.env_language === 'zh') {

    // SPECIAL CAROUSEL (Slick) FOR "ZH" language (no alphabetic order)

    const eventAllSports = new AnalyticsSlickEvent('SportAdvice-SlickCarousel', tracker.defaultEvent());

    eventAllSports.domContainer = '.sports-advice-carousel';
    eventAllSports.domElement = 'a';
    eventAllSports.options.action = 'HPAllSports';

    eventAllSports.trackDots();
    eventAllSports.trackArrows();
    eventAllSports.trackElements({
      vars: {
        classSportName: 'sprite-sport-product-',
        selectorParent: 'span.sprite-sport-product',
        selectorType: 'class',
      },
      getLabel($element, _indexElement, _indexFloor) {
        // Sport's name is contained at the end of the div's className (e.g. "sprite-sport-product-tennis").
        // We search for the className that starts with 'sprite-sport-product-' and remove this value from the founded string.
        let sportName = 'unknown';
        const searchedClass = this.vars.classSportName;
        const sportClass = $.grep($element.find(this.vars.selectorParent).attr(this.vars.selectorType).split(' '), (v, i) => v.indexOf(searchedClass) === 0).join();
        if (sportClass !== null)
          sportName = sportClass.replace(searchedClass, '');
        return AnalyticsConstants.slick.defaultValuePosition +  _indexElement + AnalyticsConstants.concatenator + sportName;
      }
    });

    eventAllSports.postAction(($element) => {
      let urlCategory = fwk.utils.getInfoNavFromURL($element.attr('href'), false);
      if (urlCategory !== null && urlCategory !== '' && urlCategory.endsWith('_')) {
        urlCategory = urlCategory.substr(0,urlCategory.length -2);
      }

      if (urlCategory !== null && urlCategory !== '') {
        const splitUrlCategory = urlCategory.split('/');
        urlCategory = splitUrlCategory[splitUrlCategory.length - 1];
      }

      fwk.shoppingtool.set('navigation', urlCategory);
	    });

    tracker.addEvent(eventAllSports);

  } else {

    // DEFAULT CAROUSEL > ALPHABETICAL ORDER

    // - CLICK SPORT
    const clickSport = new AnalyticsClickEvent('SportAdvice-ClickSport', tracker.defaultEvent());
    clickSport.domContainer = defaultContainer;
    clickSport.domElement = '.line > a';
    clickSport.getLabel = function($element) {
      const sportName = $element.data('ordering-text');
      const sportPosition = $(this.domContainer).find(this.domElement).index($element) + 1;
      return `Position-${  sportPosition  }${sep  }${sportName}`;
    };

    clickSport.postAction(($element) => {
      let urlCategory = fwk.utils.getInfoNavFromURL($element.attr('href'), false);
      if (urlCategory !== null && urlCategory !== '' && urlCategory.endsWith('_')) {
        urlCategory = urlCategory.substr(0,urlCategory.length -2);
      }
      fwk.shoppingtool.set('navigation', urlCategory);
	    });

    tracker.addEvent(clickSport);

    // - CLICK LETTER
    const clickLetter = new AnalyticsClickEvent('SportAdvice-ClickLetter', tracker.defaultEvent());
    clickLetter.domContainer = defaultContainer;
    clickLetter.domElement = '#sportsAdviceCarouselNav > div.bullet';
    clickLetter.getLabel = ($element) => `Click-${  $element.data('value')}`;
    tracker.addEvent(clickLetter);

  }

  // CLICK on category tabs link
  $('#category-tabs .category-tabs-list a').on('click.st', function() {
    let urlCategory = fwk.utils.getInfoNavFromURLForShoppingTool($(this).attr('href'));
    if (urlCategory !== null && urlCategory !== '' && urlCategory.endsWith('_')) {
      urlCategory = urlCategory.substr(0,urlCategory.length -2);
    }

    if (urlCategory !== null && urlCategory !== '') {
      const splitUrlCategory = urlCategory.split('/');
      urlCategory = splitUrlCategory[splitUrlCategory.length - 1];
    }

    CUBE.Analytics.shoppingtool.set('navigation', urlCategory);
  });

  // - DEFAULT SEARCH IN
  const clickSearch = new AnalyticsClickEvent('SportAdvice-ClickSearch', tracker.defaultEvent());
  clickSearch.domContainer = defaultContainer;
  clickSearch.domElement = '#sportsAdviceFilteredList li > a';
  clickSearch.getLabel = ($element) => {
    const searchedValue = $('#sportsAdviceFilter').val().trim().toUpperCase();
    const clickedValue = $element.data('ordering-text');
    return `Search-${  searchedValue  }${sep  }${clickedValue}`;
  };
  tracker.addEvent(clickSearch);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);

};



// WEBPACK FOOTER //
// ./src/analytics/trackers/homepage/sports-advice-tracker.js